// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #011029;
  min-height: calc(100vh - 64px - 1rem);
  width: 100%;
}

.dashboard-container h1 {
  color: white;
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

.dashboard-nav {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #2d2d2d;
  padding-bottom: 1rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}

.nav-tab {
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  color: #666;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s;
}

.nav-tab:hover {
  color: #fff;
}

.nav-tab.active {
  color: #fff;
  border-bottom: 2px solid #0ea5e9;
}

.dashboard-content {
  background: #1a1a1a;
  border-radius: 8px;
  padding: 2rem;
  color: white;
}

.analytics-section {
  margin-bottom: 2rem;
}

.analytics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.analytics-card {
  background: #2d2d2d;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
}

.analytics-card h3 {
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.analytics-card p {
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;
}

.completion-rate {
  color: #0ea5e9 !important;
  font-size: 0.875rem !important;
  margin-top: 0.5rem;
}

.submissions-list,
.activity-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.submission-card,
.activity-card {
  background: #2d2d2d;
  padding: 1rem;
  border-radius: 8px;
}

.submission-card h3,
.activity-card h4 {
  color: #fff;
  margin-bottom: 0.5rem;
}

.submission-card p,
.activity-card p {
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.type-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
}

.type-card {
  background: #2d2d2d;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
}

.type-card h4 {
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.type-card p {
  color: #fff;
  font-size: 1.25rem;
  font-weight: bold;
}

/* Make tabs scrollable on mobile */
@media (max-width: 768px) {
  .dashboard-nav {
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }

  .dashboard-nav::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  .dashboard-container {
    padding: 0.5rem 1rem 1rem 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE;IACE,iCAAiC;IACjC,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,gBAAgB;EAC5C;;EAEA;IACE,aAAa,EAAE,0BAA0B;EAC3C;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".dashboard-container {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  background-color: #011029;\n  min-height: calc(100vh - 64px - 1rem);\n  width: 100%;\n}\n\n.dashboard-container h1 {\n  color: white;\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.dashboard-nav {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #2d2d2d;\n  padding-bottom: 1rem;\n  overflow-x: auto;\n  padding-bottom: 0.5rem;\n}\n\n.nav-tab {\n  padding: 0.5rem 1rem;\n  border: none;\n  background: none;\n  color: #666;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.nav-tab:hover {\n  color: #fff;\n}\n\n.nav-tab.active {\n  color: #fff;\n  border-bottom: 2px solid #0ea5e9;\n}\n\n.dashboard-content {\n  background: #1a1a1a;\n  border-radius: 8px;\n  padding: 2rem;\n  color: white;\n}\n\n.analytics-section {\n  margin-bottom: 2rem;\n}\n\n.analytics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.analytics-card {\n  background: #2d2d2d;\n  padding: 1.5rem;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.analytics-card h3 {\n  color: #666;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.analytics-card p {\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.completion-rate {\n  color: #0ea5e9 !important;\n  font-size: 0.875rem !important;\n  margin-top: 0.5rem;\n}\n\n.submissions-list,\n.activity-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.submission-card,\n.activity-card {\n  background: #2d2d2d;\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.submission-card h3,\n.activity-card h4 {\n  color: #fff;\n  margin-bottom: 0.5rem;\n}\n\n.submission-card p,\n.activity-card p {\n  color: #666;\n  font-size: 0.875rem;\n  margin-bottom: 0.25rem;\n}\n\n.type-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1rem;\n}\n\n.type-card {\n  background: #2d2d2d;\n  padding: 1rem;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.type-card h4 {\n  color: #666;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.type-card p {\n  color: #fff;\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n/* Make tabs scrollable on mobile */\n@media (max-width: 768px) {\n  .dashboard-nav {\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n  }\n\n  .dashboard-nav::-webkit-scrollbar {\n    display: none; /* Chrome, Safari, Opera */\n  }\n\n  .dashboard-container {\n    padding: 0.5rem 1rem 1rem 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
